import { CapoPlugin } from "C:/Install/Projects/lk_creative/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];